var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.container},[_c('div',{staticClass:"image-background",style:({..._vm.backgroundImage})}),_c('div',{staticClass:"list-2",style:({..._vm.backgroundColor, ..._vm.shadow, ..._vm.padding})},[_c('b-list-group',{style:({..._vm.color})},[_vm._t("list")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }